import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/ScannedDocuments/novalidated';

export const getNoValidatedSD = async ({ page, size, filters }) => {
  if (!filters.docket_number) {
    delete filters.docket_number;
  }
  try {
    const response = await axios.get(
      endPoint.concat(getQueryData(page, size, filters)),
      {},
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
